<template>
	<RouterView />
</template>

<script>
export default {
	name: 'LandingView'
}
</script>
